import {Component, Inject, OnInit} from '@angular/core';

import {AlertService, AuthenticationService, ProjectControlItemService,} from '../../_services/index';

import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DictionaryItem} from "../../_models/dictionaryItem";
import {DictionaryService} from "../../_services/dictionary.service";
import {LoginHelper} from "../../helpers";

@Component({
    standalone: false,
  selector: 'send-project-control-item-message-component',
  templateUrl: 'send-project-control-item-message.component.html',
  styleUrls: ['./send-project-control-item-message.component.css'],
})

export class SendProjectControlItemMessageComponent implements OnInit {
  projectControlItemId: number;
  form: FormGroup;
  visibility :any = {};

  constructor(
    public dialogRef: MatDialogRef<SendProjectControlItemMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public projectControlItemService: ProjectControlItemService,
    public alertService: AlertService,
    public formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.projectControlItemId = this.data.projectControlItemId;
    this.form = this.formBuilder.group({
      text: ['', Validators.required],
    });
  }

  onSave() {
    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }

    this.alertService.clear();

    this.projectControlItemService.sendProjectControlItemMessage(this.form.value.text, this.projectControlItemId)
      .subscribe(
        data => {
          this.onClose();
        },
        error => {
            const message = "An error occurred while updating item.";
            this.alertService.error(message);
        });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
